import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { store } from './redux/redux.store';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { LocaleProvider } from './i18n/LocaleContext';

import './assets/css/index.css';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <React.StrictMode>
    <div className="App">
      <Provider store={store}>
        <LocaleProvider>
          <App />
        </LocaleProvider>
      </Provider>
    </div>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
